import { styled as muiStyled } from '@mui/material'

// react-calendar (v4) real class names used below:
//   today          -> .react-calendar__tile--now       (NOT --today)
//   selected       -> .react-calendar__tile--active     (NOT --selected)
//   weekend        -> .react-calendar__month-view__days__day--weekend
//   neighbour month-> .react-calendar__month-view__days__day--neighboringMonth
//   off day        -> .react-calendar__tile--off-day    (added by us via tileClassName)
// Colours are solid (not translucent) so every tile stays legible on the white popover.
export const DayJsDateSelectorCalendarStyleContainer = muiStyled('div')(
  ({ theme }) => `
    .react-calendar {
        border: none;
        font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        line-height: 1.2em;
        width: 19em;
        transition: background 200ms linear;
        border-radius: 8px;
        padding: 8px;
        background: #ffffff;
    }

    /* Navigation buttons (month/year label + arrows) */
    .react-calendar__navigation {
        display: flex;
        height: 44px;
        margin-bottom: 0.5em;
    }

    .react-calendar__navigation button {
        min-width: 44px;
        background: none;
        font-size: 15px;
        margin-top: 8px;
        color: #4338ca;
        font-weight: 600;
        border-radius: 6px;
        transition: all 0.2s ease;
    }

    .react-calendar__navigation button:enabled:hover,
    .react-calendar__navigation button:enabled:focus {
        background-color: rgba(67, 56, 202, 0.1);
        color: #3730a3;
    }

    .react-calendar__navigation button:disabled {
        background: none;
        color: #c7cad1;
    }

    /* Weekday labels (Mon Tue …) — solid slate, no underline on the abbr */
    .react-calendar__month-view__weekdays {
        text-align: center;
        text-transform: uppercase;
        font-weight: 700;
        font-size: 0.72em;
        color: #64748b;
        margin-bottom: 6px;
    }

    .react-calendar__month-view__weekdays__weekday {
        padding: 0.5em;
    }

    .react-calendar__month-view__weekdays__weekday abbr {
        text-decoration: none;
        cursor: default;
    }

    /* Date / month / year tiles — solid dark text for maximum legibility */
    .react-calendar__tile {
        max-width: 100%;
        padding: 10px 6.6667px;
        background: none;
        text-align: center;
        line-height: 16px;
        font-size: 0.833em;
        border-radius: 6px;
        transition: all 0.15s ease;
        color: #1e293b;
        font-weight: 500;
    }

    .react-calendar__tile:enabled:hover,
    .react-calendar__tile:enabled:focus {
        background-color: rgba(67, 56, 202, 0.1);
        color: #3730a3;
    }

    /* Weekends are NOT inherently off days — neutralise react-calendar's default red so only
       schedule-derived off days (below) show red. */
    .react-calendar__month-view__days__day--weekend {
        color: #1e293b;
    }

    /* Dates outside the visible month */
    .react-calendar__month-view__days__day--neighboringMonth {
        color: #cbd5e1;
    }

    /* Today */
    .react-calendar__tile--now {
        background: rgba(67, 56, 202, 0.12);
        color: #3730a3;
        font-weight: 700;
        border: 1.5px solid rgba(67, 56, 202, 0.35);
    }

    .react-calendar__tile--now:enabled:hover,
    .react-calendar__tile--now:enabled:focus {
        background: rgba(67, 56, 202, 0.2);
        border-color: rgba(67, 56, 202, 0.5);
    }

    /* Selected date */
    .react-calendar__tile--active,
    .react-calendar__tile--active:enabled:hover,
    .react-calendar__tile--active:enabled:focus {
        background: linear-gradient(135deg, #4338ca 0%, #6366f1 100%);
        color: #ffffff;
        font-weight: 700;
        border: none;
    }

    /* Off days (e.g. clinic-closed weekdays) — red, but still selectable */
    .react-calendar__tile--off-day {
        color: #dc2626;
        font-weight: 600;
        background: rgba(220, 38, 38, 0.07);
    }

    .react-calendar__tile--off-day:enabled:hover,
    .react-calendar__tile--off-day:enabled:focus {
        background: rgba(220, 38, 38, 0.15);
        color: #b91c1c;
    }

    /* Off day that is also today */
    .react-calendar__tile--off-day.react-calendar__tile--now {
        background: rgba(220, 38, 38, 0.14);
        border-color: rgba(220, 38, 38, 0.4);
        color: #b91c1c;
    }

    /* Off day that is also selected — solid red so the choice reads clearly */
    .react-calendar__tile--off-day.react-calendar__tile--active {
        background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
        color: #ffffff;
    }

    /* Disabled dates (before minDate / after maxDate) */
    .react-calendar__tile:disabled {
        background-color: #f8fafc;
        color: #cbd5e1;
        cursor: not-allowed;
    }
`,
)
